import React, { useState, useEffect, useMemo } from 'react';
import { FlatList, ScrollView, SectionList, TouchableOpacity, View } from 'react-native'

import api from "../../../../../utils/api"
import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';

import dayjs from 'dayjs'
import IconButton from '../../../../../components/IconButton';
import NewExpenseModal from './NewExpenseModal';
import { currency, money } from '../Reports/ReportsSection';
import { MonthSelector, MonthSelectorDropdown, MonthSelectorModal } from '../../../../../components/Forms/MonthSelector';


const MONTHS = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]

function ExpenseRow({ expense }) {
  const dateStr = dayjs(expense.apply_date).format('D/MM/YYYY')

  return (
    <View style={tw`bg-white rounded-2xl border border-gray-200 px-4 py-3 mb-3`}>
      <View style={tw`row justify-between items-start mb-1`}>
        <Text style={tw`flex-1 text-secondary text-base font-500 pr-3`}>{expense.name}</Text>

        <Text style={tw`text-red-500 font-600`}>${expense.amount.toLocaleString()}</Text>
      </View>

      <View style={tw`row justify-between items-end`}>
        <View style={tw``}>
          <Text style={tw`text-gray-500`}>{dateStr}</Text>

          {
            expense.payment_method &&
            <Text style={tw`text-gray-500`}>{expense.payment_method.name}</Text>
          }
        </View>

        {
          expense.category?.name &&
            <Text style={tw`text-gray-500`}>{expense.category?.name}</Text>
        }
      </View>

      {
        expense.images?.length > 0 &&
        <Image source={expense.images[0].thumbnails?.['250']?.url} style={tw`w-20 h-20 rounded-lg mt-2`} contentFit='cover' />
      }
    </View>
  )
}


export default function ExpensesSection({ communityId }) {
  const [showNewExpenseModal, setShowNewExpenseModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [showMonthSelectorModal, setShowMonthSelectorModal] = useState(false);

  const monthISO = selectedMonth.toISOString().split("T")[0]

  const { isInitialLoading, error, data: expenses, refetch } = useQuery({
    queryKey: ['community.accounting.expenses', communityId, monthISO],
    queryFn: () => api.get(`/communities/${communityId}/expenses?month=${monthISO}`).then(response => response.data),
  })

  const periodTotal = useMemo(() => {
    return expenses?.reduce((acc, cur) => acc + cur.amount, 0)
  }, [expenses])

  const periodLabel = `${MONTHS[selectedMonth.getMonth()]} ${selectedMonth.getFullYear()}`

  const listHeader = (
    <View>
      {/* Card de gastos del mes */}
      <View style={tw`bg-[#FBF5FF] border border-secondary/20 rounded-2xl px-5 py-4 mb-4`}>
        <TouchableOpacity
          style={tw`row justify-between items-center bg-secondary/10 rounded-xl px-4 py-3 mb-4`}
          onPress={() => setShowMonthSelectorModal(true)}
        >
          <Text style={tw`text-secondary font-500`}>{periodLabel}</Text>
          <Icon name='chevron-right' size={13} color={tw.color('secondary')} style={{ transform: [{ rotateZ: '90deg' }] }} />
        </TouchableOpacity>

        <Text style={tw`text-gray-500`}>Total de gastos</Text>
        <Text style={tw`text-secondary font-700 text-4xl`}>{money(periodTotal)}</Text>
        <Text style={tw`text-gray-400 text-sm mt-1`}>
          {(expenses?.length ?? 0)} gasto{(expenses?.length ?? 0) !== 1 ? 's' : ''} registrado{(expenses?.length ?? 0) !== 1 ? 's' : ''}
        </Text>
      </View>

      {
        isInitialLoading &&
          <Text style={tw`my-8 text-lg text-center text-gray-400`}>Cargando...</Text>
      }

      {
        !isInitialLoading && expenses?.length == 0 &&
          <Text style={tw`mt-10 text-lg text-center text-gray-400`}>Sin gastos registrados</Text>
      }
    </View>
  )


  return (
    <View style={tw`flex-1 bg-background`}>
      <FlatList
        data={expenses}
        ListHeaderComponent={listHeader}
        contentContainerStyle={tw`px-4 pt-4 pb-24`}
        renderItem={({ item }) => <ExpenseRow expense={item} />}
        keyExtractor={(item) => item.uuid}
      />

      {
        showMonthSelectorModal &&
          <MonthSelectorModal
            onRequestClose={() => setShowMonthSelectorModal(false)}
            selectedDate={selectedMonth}
            onChange={date => {
              setShowMonthSelectorModal(false)
              setSelectedMonth(date)
            }}
          />
      }

      <IconButton
        title={"Registrar Gasto"}
        color='secondary'
        textColor='white'
        style={tw`absolute bottom-0 w-full rounded-t-2xl rounded-b-0 py-3`}
        onPress={() => setShowNewExpenseModal(true)}
      />


      {
        showNewExpenseModal &&
          <NewExpenseModal
            communityId={communityId}
            onRequestClose={() => setShowNewExpenseModal(false)}
            onExpenseCreated={() => {
              setShowNewExpenseModal(false)
              refetch()
            }}
            visible
          />
      }
    </View>
  )
}